// カラーパレット定義
export const colors = {
  // テキストカラー
  text: {
    light: '#8A95A5',     // ライトグレー - 補助説明文
    dark: '#2D3138',      // ダークグレー/チャコール - 見出し・強調
    primary: '#2D3138',   // メインテキスト
    secondary: '#8A95A5', // サブテキスト
  },
  
  // アクセントカラー
  accent: {
    coral: '#E85C56',     // コーラルレッド/サーモンピンク - アラート・強調
    blue: '#4D8FEA',      // ブルー - リンク・主要アクション
    red: '#E85C56',       // レッド（coralと同じ）
    purple: '#9B59B6',    // パープル
    green: '#5CC8A1',     // グリーン（successと同じ）
    orange: '#F5A623',    // オレンジ
    cyan: '#06B6D4',      // シアン
    gold: '#FFD700',      // ゴールド（1位）
    silver: '#C0C0C0',    // シルバー（2位）
    bronze: '#CD7F32',    // ブロンズ（3位）
  },
  
  // 補助カラー
  support: {
    gray: '#E6E9EF',      // UI枠や区切り線
    success: '#5CC8A1',   // ブルーグリーン - 成功メッセージ
  },
  
  // 背景色
  background: {
    primary: '#FFFFFF',   // 純白背景
    secondary: '#FAFBFC', // 微妙にグレーがかった背景
    hover: '#F5F6F8',     // ホバー時の背景
  },
  
  // 状態色
  status: {
    error: '#E85C56',     // エラー（コーラルレッドを使用）
    warning: '#F5A623',   // 警告
    success: '#5CC8A1',   // 成功
    info: '#4D8FEA',      // 情報
  },
  
  // UI要素用の色
  ui: {
    bg: '#FFFFFF',         // 主背景
    bgSecondary: '#F8F9FA', // セカンダリ背景
    border: '#E6E9EF',    // ボーダー
    borderHover: '#D1D5DB',
    shadow: 'rgba(0, 0, 0, 0.1)',
    backdrop: 'rgba(0, 0, 0, 0.5)',
    disabled: '#9CA3AF',
    success: '#5CC8A1',   // 成功メッセージ（support.successと同じ）
  }
};

// エージェント別のテーマカラー
export const agentThemes = {
  md: {
    primary: '#4D8FEA',
    secondary: '#E6E9EF',
    accent: '#5CC8A1',
    icon: '📊',
    name: 'MDエージェント'
  },
  marketing: {
    primary: '#E85C56',
    secondary: '#FFE5E3',
    accent: '#4D8FEA',
    icon: '📣',
    name: 'マーケティングエージェント'
  },
  planogram: {
    primary: '#5CC8A1',
    secondary: '#E0F5EC',
    accent: '#4D8FEA',
    icon: '🏪',
    name: 'プラノグラムエージェント'
  },
  creative: {
    primary: '#F5A623',
    secondary: '#FFF3E0',
    accent: '#E85C56',
    icon: '🎨',
    name: 'クリエイティブエージェント'
  }
};

// タイポグラフィ
export const typography = {
  fontFamily: {
    base: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Noto Sans JP", sans-serif',
    mono: 'SF Mono, Monaco, Consolas, "Courier New", monospace',
  },
  fontSize: {
    xs: '0.75rem',    // 12px
    sm: '0.875rem',   // 14px
    base: '1rem',     // 16px
    lg: '1.125rem',   // 18px
    xl: '1.25rem',    // 20px
    '2xl': '1.5rem',  // 24px
    '3xl': '1.875rem',// 30px
    '4xl': '2.25rem', // 36px
  },
  fontWeight: {
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
  lineHeight: {
    tight: 1.2,
    normal: 1.5,
    relaxed: 1.75,
  }
};

// スペーシング
export const spacing = {
  xs: '0.25rem',  // 4px
  sm: '0.5rem',   // 8px
  md: '1rem',     // 16px
  lg: '1.5rem',   // 24px
  xl: '2rem',     // 32px
  '2xl': '2.5rem',// 40px
  '3xl': '3rem',  // 48px
  '4xl': '4rem',  // 64px
};

// シャドウ
export const shadows = {
  sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
  base: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
  md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
  lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
  xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
};

// ボーダー半径
export const borderRadius = {
  sm: '0.25rem',  // 4px
  base: '0.5rem', // 8px
  md: '0.75rem',  // 12px
  lg: '1rem',     // 16px
  xl: '1.5rem',   // 24px
  full: '9999px',
};

// トランジション
export const transitions = {
  fast: '150ms ease-in-out',
  base: '200ms ease-in-out',
  slow: '300ms ease-in-out',
};

// Z-index
export const zIndex = {
  dropdown: 1000,
  modal: 1050,
  popover: 1060,
  tooltip: 1070,
};

// 互換性のためのエクスポート（すべての定義後に配置）
export const agentColors = colors.accent;
export const fontSize = typography.fontSize;
export const fontWeight = typography.fontWeight;

export default {
  colors,
  agentThemes,
  typography,
  spacing,
  shadows,
  borderRadius,
  transitions,
  zIndex,
};